module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensedItalic-webfont.svg?74e580632303ca4124c87af2431743fa";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensedItalic-webfont.svg
// module id = 55
// module chunks = 0